import React from 'react'
import { Button, ModalDialog, CustomLinks } from 'components'

const linksOptions = { renderers: { paragraph: 'span' } }

function AcceptTermsDialog({ show, onConfirm, ...props }) {
  return (
    <ModalDialog
      show={show}
      actionButton={
        <Button primary="true" onClick={onConfirm}>
          I agree!
        </Button>
      }
      cancelText="I don't agree. Log me out"
      hideSubtitle
      {...props}
    >
      <p className="normal-font">
        By signing in, you are indicating your agreement with the&nbsp;
        <CustomLinks location="FOOTER.TERMS_SERVICE" options={linksOptions} />
        {' and the '}
        <CustomLinks location="FOOTER.DATA_TERMS" options={linksOptions} />
      </p>
    </ModalDialog>
  )
}

export default AcceptTermsDialog
